<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="width: 250px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >ORDER DINE IN</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <div v-for="subItem in filteredSidebar" :key="subItem.title">
          <v-list-tile :to="subItem.url">
            <v-list-tile-action>
              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                v-if="subItem.check == 'new_order'"
                fab
                color="primary"
                style="height: 28px; width: 28px"
                class="black--text"
                >{{ orderListNewOrder.length }}</v-btn
              >
              <v-btn
                v-else-if="subItem.check == 'on_process'"
                fab
                color="primary"
                style="height: 28px; width: 28px"
                class="black--text"
                >{{ orderListOnProcess.length }}</v-btn
              >
            </v-list-tile-action>
          </v-list-tile>
          <hr v-if="subItem.no_filter_date == true" />
        </div>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      title: "",
      items: [
        {
          icon: "mdi-alert-decagram",
          title: "New Order",
          check: "new_order",
          order_status: 1,
          permission_name: "order_new_order",
          url: "/weserve_admin_login/-/maindinein/order/new-order",
          no_filter_date: false,
        },
        {
          icon: "access_alarm",
          title: "On process",
          check: "on_process",
          order_status: 2,
          permission_name: "order_on_process",
          url: "/weserve_admin_login/-/maindinein/order/on-process",
          no_filter_date: true,
        },
        {
          icon: "check_circle",
          title: "Complete",
          check: "complete",
          order_status: 3,
          permission_name: "order_complete",
          url: "/weserve_admin_login/-/maindinein/order/complete",
        },
        {
          icon: "cancel",
          title: "Cancel",
          check: "cancel",
          order_status: 4,
          permission_name: "order_cancel",
          url: "/weserve_admin_login/-/maindinein/order/cancel",
        },
      ],
      intervalCountOrder: null,
    };
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
      orderListOnProcess: (state) => state.fetchDineIn.orderListOnProcess,
      orderListNewOrder: (state) => state.fetchDineIn.orderListNewOrder,
    }),
    filteredSidebar() {
      return this.items.filter((val) => {
        for (let val2 in this.permission.main_menu.dine_in_management
          .order_list) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
  watch: {
    orderListNewOrder(newValue, oldValue) {
      this.setOrderTitle();
    },
  },
  methods: {
    ...mapActions({
      fetchOrderList: "fetchDineIn/fetchOrderList",
    }),
    setOrderTitle() {
      document.title =
        this.orderListNewOrder.length > 0
          ? `(${this.orderListNewOrder.length}) ${this.title}`
          : this.title;
    },
    filterSubSidebar(item) {
      return item.items.filter((val) => {
        for (let val2 in this.permission.main_menu.dine_in_management[
          item.permission_name
        ]) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
    async fetchOrderDineIn() {
      return this.fetchOrderList({
        order_status: [1, 2],
      });
    },
    async getData() {
      await this.fetchOrderDineIn();
      let vm = this;
      this.intervalCountOrder = setInterval(async function () {
        vm.fetchOrderDineIn();
      }, 60000);
    },
  },
  beforeDestroy() {
    document.title = this.title;
    clearInterval(this.intervalCountOrder);
  },
  created() {
    this.title = document.title;
  },
  mounted() {
    this.getData();
  },
};
</script>
